module.exports = __webpack_public_path__ + "static/curso03-f8e5a1129963a39f7e3a658c0c814baa.png";